const e = { last_updated: "Senest opdateret", Series_type: "Serie", "How to guide_type": "Vejledning", FAQ_type: "Standard" }, t = {
  articles: e
};
export {
  e as articles,
  t as default
};
//# sourceMappingURL=help-center-knowledge-anatomies36.js.map
